import { apiGet, apiPost } from './http'

export const inbox = async request => apiPost('/messages/inbox/findall', request, { auth: true })

export const send = async request => apiPost('/messages/send/findall', request, { auth: true })

export const create = async request => apiPost('/messages/admin/create', request, { auth: true })

export const detail = async request => apiPost('/messages/detail', request, { auth: true })

export const categories = async () => apiGet('/messages/categories/findall', { auth: true })

export const recipients = async request =>
  apiPost('/messages/recipients/findall', request, { auth: true })

export const sendMessage = async request =>
  apiPost('/messages/status/change', request, { auth: true })

export const changeStatus = async request =>
  apiPost('/messages/recipients/status/change', request, { auth: true })
